var title=null;

var doTitle = {
    init : function() {
        if (!title) {
            title = new Title({width:WIDTH, height:HEIGHT, x:X,y:Y, backgroundImage:"images/Title.jpg", opacity:0});
            game.add(title);
        }
        title.opacity = 1;
        title.visible = true;
        title.animate({opacity:1},1);
    },
    update : function(delta) {

    },
    shutDown : function() {
        title.animate({opacity:0},1, function(o) {
            o.visible = false;
        });
    }
}

class Title extends View {
    constructor(dat) {
        super(dat);
    }
    onMouseDown(m) {
        game.states.setState("WORLD");
    }

}